import Breadcrumb from "components/common/Breadcrumb/Breadcrumb";
import DateRangePickerNew from "components/common/DateRangePicker/DateRangePickerNew";
import Header from "components/common/Header/Header";
import SelectOption from "components/common/Select/Select";
import SideBarNew from "components/common/SideBar/SideBarNew";
import {
  REPORTING_BREADCRUMB,
  REPORTING_BREADCRUMB_PAGES,
} from "Constants/BreadcrumbConstant";
import { LoginContext } from "helpers/LoginContext";
import React, { useContext, useEffect, useState } from "react";
import PaginationComponent from "components/common/Pagination/index";
import {
  DOC_DOWNLOAD_URL,
  emptyPaginationObj,
  REPORTING_LIMIT,
  SORT_TYPE,
  SYSTEM_ROLES,
  SYSTEM_ROLES_REPORTING,
  USER_ROLE_TITLE,
} from "Constants/constant";
import CircularLoader from "components/common/CircularLoader/CircularLoader";
import TableHeader from "components/common/Table/TableHeader";
import { apiGetRequest, apiPostRequest } from "helpers/Requests";
import {
  URL_REPORTING_CASE_NOTES_REPORTS,
  URL_REPORTING_GET_SP_USERS_LIST,
} from "store/services/URL";

import moment from "moment";
import { toast } from "react-toastify";
import {
  addMonths,
  exportTOExcel,
  formatDateReporting,
  truncateTextReporting,
} from "Utils/utils";
import useReportExport from "../useReportExport";
import {
  ReportFilterActions,
  ReportFilterField,
  ReportFilterGrid,
  ReportFilterSearchField,
  ReportFiltersShell,
  ReportPageContent,
  ReportTableSection,
} from "../reportFilterUi";
import { withReportSortOnUrl } from "../reportExportUtils";
import PopoverContainer from "components/common/Popover/PopoverContainer";
import useCareLabels from "hooks/useCareLabels";

const CaseNoteReports = ({ getParticipantList, spParticipants }) => {
  const { sideBarPadding, isUserGracePeriodOver } = useContext(LoginContext);
  const { participantLabel, participantNameLabel } = useCareLabels();
  const searchByParticipantLabel = `Search by ${participantNameLabel}`;
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    const filters = {
      page: 1,
      per_page: 500,
      search: null,
    };
    getParticipantList({ filters, bodyFilter: null });
  }, []);

  const [participantList, setParticipant] = useState([
    { label: "All", value: "all" },
  ]);
  const [selectedParticipant, setSelectedParticipant] = useState(null);

  const [search, setSearch] = useState(null);

  const [reportList, setReports] = useState(null);
  const [loader, setLoader] = useState(false);
  const [paginationObj, setPaginationObj] = useState(emptyPaginationObj);
  const [page, setPage] = useState(1);
  const [sortDescending, setSortDescending] = useState(
    paginationObj.sort_order === SORT_TYPE.DESC ? true : false
  );
  const [sortBy, setSortBy] = useState(paginationObj.sort_field);

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const [role, setRole] = useState(null);
  const [userName, setUserName] = useState(null);
  const [selectedFromDate, setSelectedFromDate] = useState(null);
  const [isDisableSearch, setIsDisableSearch] = useState(false);
  useEffect(() => {
    const updateLists = async () => {
      const participants =
        spParticipants?.participant?.data?.map((item) => ({
          label: `${item?.first_name} ${item?.last_name}`,
          value: item?.id,
        })) || [];

      const sortedParticipants = participants.sort((a, b) =>
        a.label.toLowerCase().localeCompare(b.label.toLowerCase())
      );

      setParticipant([{ label: "All", value: "all" }, ...sortedParticipants]);
    };

    updateLists();
  }, [spParticipants]);

  useEffect(() => {
    apiGetRequest(URL_REPORTING_GET_SP_USERS_LIST)
      .then((res) => {
        if (res.status === 200) {
          const userNames = res.data?.data || [];
          const users =
            userNames.length > 0
              ? userNames.map((user) => ({
                  label: user?.name,
                  value: user?.id,
                }))
              : [];
          const sortedData = users?.sort((a, b) =>
            a.label.toLowerCase().localeCompare(b.label.toLowerCase())
          );
          setUserName([{ label: "All", value: "all" }, ...sortedData]);
          // setUserName(users);
        }
      })
      .catch((error) => {
        console.log({ error });
      });
  }, []);

  const [isInitialRender, setIsInitialRender] = useState(true);
  const { runExport, QueuedModal, getExportSortFilters } = useReportExport(
    "casenote_report",
    "Case Note Report",
    { sortBy, sortDescending }
  );

  useEffect(() => {
    if (isInitialRender) {
      setIsInitialRender(false);
      return;
    }

    fetchListReports();
  }, [page]);

  const fetchListReports = async (
    isClearAll = false,
    report = null,
    filters = null
  ) => {
    if (!fromDate && !toDate) {
      toast("Select date range to get data");
      return;
    }
    setLoader(true);
    let url = `${URL_REPORTING_CASE_NOTES_REPORTS}?per_page=25&page=${page}`;
    url = withReportSortOnUrl(url, filters || {}, sortBy, sortDescending);
    const payload = {
      search: search ? search : "",
      participant: isClearAll
        ? "all"
        : selectedParticipant
        ? selectedParticipant?.value
        : "all",
      user_id: isClearAll ? "all" : selectedUser ? selectedUser?.value : "all",

      role: isClearAll ? "all" : role ? role?.value : "all",
      date_range_created: isClearAll
        ? "all"
        : toDate && fromDate
        ? [fromDate, toDate]
        : "all",
    };
    if (report) {
      await runExport({
        format: report,
        payload,
        syncUrl: url,
        filters: filters || {},
        totalRows: paginationObj?.total,
        setLoader,
        onSyncExcel: exportTOExcelFile,
        onSyncPdf: (downloadUrl) => window.open(downloadUrl, "_blank"),
      });
      return;
    }
    await apiPostRequest(url, payload)
      .then((res) => {
        if (res.status === 200) {
          setLoader(false);
          setReports(res?.data?.data);
          setPaginationObj((prev) => ({
            ...prev,
            total: res?.data?.data?.case_notes?.total,
            totalPages: Math.ceil(
              res?.data?.data?.case_notes?.total /
                res?.data?.data?.case_notes?.per_page
            ),
          }));
        }
      })
      .catch((error) => {
        toast.error(`${error}`);
        console.log({ error });
        setLoader(false);
      });
  };
  const handleFileDownLoad = (e) => {
    fetchListReports(false, e, getExportSortFilters());

    // if (e === "xlsx") {
    //   exportTOExcelFile();
    // } else {
    //   fetchListReports(false, e);
    // }
  };

  const handleSearch = () => fetchListReports(false);

  const handleClearFilters = () => {
    setSelectedUser(null);
    setRole(null);
    setSearch(null);
    setReports([]);
    setFromDate(null);
    setToDate(null);
    setSelectedParticipant(null);
    setSelectedFromDate(null);
  };

  const exportTOExcelFile = (reportData) => {
    const transformedData =
      reportData &&
      reportData?.case_notes?.length > 0 &&
      reportData?.case_notes?.map((item) => {
        return {
          Date: item?.date && moment(item?.date).format("DD/MM/YYYY"),
          Attachment: item?.attachment,
          Role: item?.author?.user_type,

          Subject: item?.title ? item.title : "N/A",
          Description: item?.notes ? item.notes.replace(/<[^>]+>/g, "") : "",

          Billable: item?.is_billable ? (item.is_billable === true ? 'Yes' : 'No') : "N/A",
          TimeSpent: item?.duration ? item.duration : "N/A",
          Contact: item?.contact_method ? item.contact_method : "N/A",
          Travel: item?.distance_km ? item.distance_km+" KM" : "N/A",
          NonDirect: item?.non_direct_support ? (item.non_direct_support === true ? 'Yes' : 'No') : "N/A",

          UserName: `${item?.author?.name}`,
          [participantLabel]: `${item?.participant?.first_name} ${item?.participant?.last_name}`,
        };
      });
    if (
      !transformedData ||
      transformedData === undefined ||
      transformedData?.length === 0
    ) {
      toast("No data found!");
      return;
    }

    exportTOExcel(transformedData);
  };

  const handleFetch = (obj) => {
    fetchListReports(false, null, { ...obj });
  };

  const flipSort = (by) => {
    setSortBy(by);
    setSortDescending(!sortDescending);
    handleFetch({
      sort_field: by,
      sort_order: !sortDescending ? SORT_TYPE.DESC : SORT_TYPE.ASC,
    });
  };

  return (
    <div className='min-h-full'>
      <SideBarNew />
      <div
        className={`${
          sideBarPadding ? "lg:pl-[4rem] duration-300" : "lg:pl-64 duration-300"
        }  flex flex-col `}
      >
        <main className='flex-1 bg-gray-50 min-h-screen'>
          <Header
            title='Case Notes Reports'
            breadcrumb={
              <Breadcrumb
                pages={REPORTING_BREADCRUMB(
                  REPORTING_BREADCRUMB_PAGES.CASE_NOTES_REPORTS
                )}
              />
            }
          />
          <ReportPageContent>
            <ReportFiltersShell>
              <ReportFilterGrid columns={4}>
                <ReportFilterField label={participantLabel}>
                  <SelectOption
                    newDesign
                    cssClass='w-full'
                    name='pt_id'
                    isSearch={true}
                    data={participantList || []}
                    selectedOption={selectedParticipant}
                    handleChange={(e) => setSelectedParticipant(e)}
                  />
                </ReportFilterField>
                <ReportFilterField label='User Name'>
                  <SelectOption
                    newDesign
                    cssClass='w-full'
                    name='user_name'
                    isSearch={true}
                    data={userName || []}
                    selectedOption={selectedUser}
                    handleChange={(e) => setSelectedUser(e)}
                  />
                </ReportFilterField>
                <ReportFilterField label='Select Date Range (Max 3 Months)' required>
                  <DateRangePickerNew
                    handleCancel={() => {
                      setFromDate(null);
                      setToDate(null);
                      setReports([]);
                    }}
                    handleChange={(obj) => {
                      if (obj) {
                        obj.fromDate && setFromDate(obj.fromDate);
                        obj.toDate && setToDate(obj.toDate);
                      }
                    }}
                    setSelectedFromDate={setSelectedFromDate}
                    fromDate={fromDate}
                    toDate={toDate}
                    maxDate={addMonths(selectedFromDate, 3)}
                    setIsDisableSearch={setIsDisableSearch}
                  />
                </ReportFilterField>
                <ReportFilterField label='Role'>
                  <SelectOption
                    newDesign
                    cssClass='w-full'
                    name='role'
                    isSearch={true}
                    data={SYSTEM_ROLES_REPORTING || []}
                    selectedOption={role}
                    handleChange={(e) => setRole(e)}
                  />
                </ReportFilterField>
                <ReportFilterSearchField
                  label={searchByParticipantLabel}
                  search={search}
                  setSearch={setSearch}
                  onSearch={handleSearch}
                  placeholder={searchByParticipantLabel}
                />
              </ReportFilterGrid>
              <ReportFilterActions
                onSearch={handleSearch}
                onClear={handleClearFilters}
                onExport={handleFileDownLoad}
                isLoading={loader}
                isSearchDisabled={isDisableSearch}
                isUserGracePeriodOver={isUserGracePeriodOver}
              />
            </ReportFiltersShell>
            <ReportTableSection>
                <table className='border min-w-full divide-y divide-gray-300'>
                  <thead
                    // style={{ top: "130px" }}
                    className='bg-gray-50 sticky z-[5]'
                  >
                    <tr>
                      <TableHeader isSort={false} label={"User Name"} cssClass='bg-blue-50 pl-4' />

                      <TableHeader isSort={false} label={"Role"} cssClass='bg-blue-50' />
                      <TableHeader isSort={false} label={participantLabel}  cssClass='bg-blue-50' />

                      <TableHeader
                        sortName='create_at'
                        flipSort={flipSort}
                        sortBy={sortBy}
                        sortDescending={sortDescending}
                        label={"Date"}
                        cssClass='bg-blue-50'
                      />

                      <TableHeader isSort={false} label={"Subject"}   cssClass='bg-blue-50' />
                      <TableHeader isSort={false} label={"Description"}   cssClass='bg-blue-50' />
                      <TableHeader isSort={false} label={"Billable"}   cssClass='bg-blue-50' />
                      <TableHeader isSort={false} label={"Time Spent"}   cssClass='bg-blue-50' />
                      <TableHeader isSort={false} label={"How Contacted"}   cssClass='bg-blue-50' />
                      <TableHeader isSort={false} label={"Travel"}   cssClass='bg-blue-50' />
                      <TableHeader isSort={false} label={"Non-direct support"}   cssClass='bg-blue-50' />
                      <TableHeader isSort={false} label={"Attachment"}   cssClass='bg-blue-50' />
                    </tr>
                  </thead>
                  <tbody className='divide-y divide-gray-200 bg-white overflow-y-auto'>
                    {loader ? (
                      <tr className='bg-white'>
                        <td colSpan={12} className='py-6 text-center bg-white'>
                          <div
                            className={`flex flex-col w-full min-h-screen  items-center justify-start`}
                          >
                            <CircularLoader
                              classes='flex justify-center items-center'
                              classloader='loader-l'
                            />
                          </div>
                        </td>
                      </tr>
                    ) : reportList !== null &&
                      reportList?.case_notes?.data?.length > 0 ? (
                      reportList?.case_notes?.data?.map((caseNote, index) => (
                          <tr
                              key={index}
                              className='even:bg-white odd:bg-gray-50'
                          >
                            <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500'>
                              {caseNote?.author
                                  ? `${caseNote?.author?.name}`
                                  : "-"}
                            </td>
                            <td className='px-2 py-[11px] text-sm text-gray-500 capitalize'>
                              {caseNote?.role || "-"}
                            </td>
                            <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500 capitalize'>
                              <div>
                                {caseNote?.participant
                                    ? `${caseNote?.participant?.first_name} ${caseNote?.participant?.last_name}`
                                    : "-"}
                              </div>
                            </td>

                            <td className='px-2 py-[11px] text-sm text-gray-500'>
                              {caseNote?.date
                                  ? moment(caseNote.date).format("DD/MM/YYYY")
                                  : "-"}
                            </td>
                            <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500 capitalize'>
                              <div
                                  className='whitespace-nowrap overflow-hidden text-gray-500 capitalize'
                                  style={{
                                    maxWidth: "100px",
                                    textOverflow: "ellipsis",
                                  }}>
                                {caseNote?.title ? (
                                    <PopoverContainer
                                        cssClass={`text-white text-sm bg-gradient p-2 rounded-md z-10`}
                                        itemComponent={() => {
                                        }}
                                        toolTip={
                                          <span
                                              dangerouslySetInnerHTML={{__html: caseNote?.title || ""}}
                                          />
                                        }
                                    >
                                    <span
                                        dangerouslySetInnerHTML={{__html: caseNote?.title}}
                                    />
                                    </PopoverContainer>
                                ) : (
                                    "N/A"
                                )}
                              </div>
                            </td>
                            <td className='whitespace-nowrap px-2 py-4 text-sm text-gray-500'>
                              <div
                                  className=' font-medium whitespace-nowrap overflow-hidden text-gray-900 capitalize'
                                  style={{
                                    maxWidth: "100px",
                                    textOverflow: "ellipsis",
                                  }}
                              >
                                {caseNote?.notes ? (
                                    <PopoverContainer
                                        cssClass={`text-white text-sm bg-gradient p-2 rounded-md z-10`}
                                        itemComponent={() => {
                                        }}
                                        toolTip={
                                          <span
                                              dangerouslySetInnerHTML={{__html: caseNote?.notes || ""}}
                                          />
                                        }
                                    >
                                    <span
                                        dangerouslySetInnerHTML={{__html: caseNote?.notes}}
                                    />
                                    </PopoverContainer>
                                ) : (
                                    "-"
                                )}
                                {/* {caseNote?.notes || "-"} */}
                              </div>
                            </td>
                            <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500 capitalize'>
                              <div>{caseNote?.is_billable ? (caseNote?.is_billable === true ? 'Yes' : 'No') : 'N/A'}</div>
                            </td>
                            <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500 capitalize'>
                              <div>{caseNote?.duration ?? 'N/A'}</div>
                            </td>
                            <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500 capitalize'>
                              <div>{caseNote?.contact_method ?? 'N/A'}</div>
                            </td>
                            <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500 capitalize'>
                              <div>{caseNote?.distance_km ? caseNote?.distance_km+" KM" : 'N/A'}</div>
                            </td>
                            <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500 capitalize'>
                              <div>{caseNote?.non_direct_support ? (caseNote?.non_direct_support === true ? 'Yes' : 'No') : 'N/A'}</div>
                            </td>

                            <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500 capitalize'>{caseNote?.attachment || "-"}</td>
                          </tr>
                      ))
                    ) : (
                        <tr>
                          <td
                              colSpan={12}
                              className='py-6 text-center text-red-600'
                          >
                            No data found. Please adjust your filters to get
                            relevant results
                          </td>
                      </tr>
                    )}
                  </tbody>
                </table>
            </ReportTableSection>

              {reportList && reportList?.case_notes?.data.length > 0 && (
                <div className='mt-3'>
                  <PaginationComponent
                    page={paginationObj?.page || 1}
                    activeListLength={reportList?.case_notes?.data || []}
                    limit={REPORTING_LIMIT}
                    totalList={paginationObj?.total}
                    handlePagination={(e) => {
                      setPage(e);
                      const obj = paginationObj;
                      obj.page = e;
                      setPaginationObj({ ...obj });
                    }}
                    totalPages={paginationObj?.totalPages}
                  />
                </div>
              )}
          </ReportPageContent>
        </main>
      </div>
      <QueuedModal />
    </div>
  );
};

export default CaseNoteReports;
